// IMPORTANT NOTE: Please don't import other selectors from this file.
// Use secondOrder and *ThirdOrder for your selector if it has other
// dependencies.
import { createSelector } from 'reselect'

import { fullSystemStateSelector } from './fullFileFirstOrder'

/**
 * @typedef {import('../index').PlottrState} PlottrState
 * @typedef {import('../types/system').ImageCache} ImageCache
 */

/**
 * @type {function(PlottrState): (ImageCache | Null)}
 */
export const imageCacheSelector = createSelector(fullSystemStateSelector, ({ imageCache }) => {
  return imageCache
})
